import Grid from '@material-ui/core/Grid'
import Input from 'Components/Input'
import Select from 'Components/Select'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'

export default class extends React.Component {

  state = {
    liaision_services: [],
    liaision_produits: [],
    connection: '',
    guestonline_period: ['breakfast', 'brunch', 'lunch', 'afternoon', 'dinner', 'no_service'],
    guestonline_restaurant: [],
  }

  async componentDidMount() {
    const guestonlineLiaision = await ApiRequest(project.api + 'interface', {
      action: 'get',
      requete: 'guestonline',
    })

    if (guestonlineLiaision && guestonlineLiaision.code === 1) {
      let guestonline_restaurant = []
      if (guestonlineLiaision.results.connection) {
        const guestonlineRestaurants = await ApiRequest(project.api + 'interface/guestonline', {
          action: 'list',
          requete: 'restaurant',
        })
        console.log(guestonlineRestaurants)
        guestonline_restaurant = guestonlineRestaurants.results.restaurants
      }

      this.setState({
        connection: guestonlineLiaision.results.connection,
        liaision_services: guestonlineLiaision.results.services || [],
        liaision_produits: guestonlineLiaision.results.produits || [],
        guestonline_restaurant: guestonline_restaurant,
        key: Utils.getRandomNumber()
      })
    }

  }

  onChangeProduitLinked = (i, produit_id) => (data) => {
    const liaision_produits = this.state.liaision_produits
    if (i === -1) {
      liaision_produits.push({
        produit_id: produit_id,
        restaurant_id: data
      })
    } else if (data === undefined) {
      liaision_produits.splice(i, 1)
    } else {
      liaision_produits[i] = {
        produit_id: produit_id,
        restaurant_id: data
      }
    }

    this.setState({
      liaision_produits: liaision_produits
    })
  }

  onChangeServiceLinked = (i, service_id) => (data) => {
    const liaision_services = this.state.liaision_services
    if (i === -1) {
      liaision_services.push({
        service_id: service_id,
        period: data
      })
    } else if (data === undefined) {
      liaision_services.splice(i, 1)
    } else {
      liaision_services[i] = {
        service_id: service_id,
        period: data
      }
    }

    this.setState({
      liaision_services: liaision_services
    })
  }

  onChangeConnection = (data) => {
    this.setState({
      connection: data
    })
  }

  handleSave = async () => {
    await ApiRequest(project.api + 'interface', {
      action: 'set',
      requete: 'guestonline',
      produits: this.state.liaision_produits.filter(lp => lp.restaurant_id !== undefined),
      services: this.state.liaision_services.filter(lp => lp.period !== undefined),
      connection: this.state.connection,
    })

    if (this.state.connection) {
      const guestonlineRestaurants = await ApiRequest('https://cors.euresto.com/https://api.guestonline.fr/v1/restaurants', {}, {
        method: 'GET',
        notSetToken: true,
      }, {
        'X-Token': this.state.connection,
      })
      this.setState({
        guestonline_restaurant: guestonlineRestaurants.restaurants
      })
    }
  }

  render() {
    return (
      <EurestoDiv
        buttonsLeft={[{
          cb: this.handleSave,
          title: EurestoI18n.t('commun:Enregistrer'),
          icon: ' ei-commun_valider'
        }]}
        title={EurestoI18n.t('commmun:Guestonline')}>
        <Grid container direction={'column'} style={{ margin: 0, padding: 20, width: '100%', position: 'relative' }}
          spacing={8} justify={'center'} alignContent={'center'} alignItems={'center'} >
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Input onChange={this.onChangeConnection} inlineWidth={80} name='connection' type='text' inline key={this.state.key}
              value={this.state.connection}
              title={EurestoI18n.t('crm:Connexion')} />
          </Grid>
          {
            this.state.guestonline_restaurant && this.state.guestonline_restaurant.length > 0 && Data.list(Constants.module.RESTAURANT, Constants.donnee.produit).length > 0 &&
            <Grid item xs={12} sm={8} md={6} lg={4}>
              <Grid container style={{ margin: 0, padding: 0, width: '100%', position: 'relative' }}
                spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>

                <Grid item xs={12}>
                  <Grid container style={{
                    margin: 0,
                    padding: 0,
                    width: '100%',
                    position: 'relative',
                  }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                    <Grid item xs={6} style={{
                      textAlign: 'left',
                      paddingLeft: 10,
                      borderRight: '1px solid black'
                    }}>
                      Restaurant Euresto
                    </Grid>
                    <Grid item xs={6} style={{ paddingLeft: 10 }}>
                      Restaurant Guestonline
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {
                    Data.list(Constants.module.RESTAURANT, Constants.donnee.produit).map((produit, i) => {
                      const restaurant_index = (this.state.liaision_produits || []).findIndex(lp => lp.produit_id === produit.id)
                      const restaurant_linked = restaurant_index !== -1 && (this.state.liaision_produits || [])[restaurant_index]
                      const restaurants = this.state.guestonline_restaurant.filter(r => this.state.liaision_produits.findIndex(lp => lp.restaurant_id === r.id && lp.produit_id !== produit.id) === -1)
                      const services = Data.list(Constants.module.RESTAURANT, Constants.donnee.service, { produit_id: produit.id })
                      return <Grid container style={{
                        margin: 0,
                        padding: 0,
                        width: '100%',
                        position: 'relative',
                        border: '1px solid black',
                        borderTop: i !== 0 && 'none' || '1px solid black'
                      }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                        <Grid item xs={12} style={{ padding: 0, borderBottom: services.length > 0 && '1px solid #A9A9A9' }}>
                          <Grid container style={{
                            margin: 0,
                            padding: 0,
                            width: '100%',
                            position: 'relative',
                          }} spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                            <Grid item xs={6} style={{
                              textAlign: 'left',
                              paddingLeft: 10,
                              borderRight: '1px solid black'
                            }}>
                              {produit.libelle}
                            </Grid>
                            <Grid item xs={6} style={{
                              padding: 10,
                            }}>
                              <Select onChange={this.onChangeProduitLinked(restaurant_index, produit.id)}
                                value={restaurant_linked && restaurant_linked.restaurant_id}
                                options={(restaurants || []).map(r => ({
                                  value: r.id,
                                  label: r.name
                                }))}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        {
                          restaurant_linked && restaurant_linked.restaurant_id && services.length > 0
                          && <Grid item xs={12} style={{ padding: 10 }}>{
                            services.map((service, j) => {

                              const service_index = (this.state.liaision_services || []).findIndex(lp => lp.service_id === service.id)
                              const service_linked = service_index !== -1 && (this.state.liaision_services || [])[service_index]
                              const periods = this.state.guestonline_period.filter(period => this.state.liaision_services.findIndex(lp => lp.period === period && lp.service_id !== service.id) === -1)
                              return <Grid container style={{
                                margin: 0,
                                padding: 0,
                                width: '100%',
                                position: 'relative',
                                border: '1px solid black',
                                borderTop: j !== 0 && 'none' || '1px solid black'
                              }}
                                spacing={0} justify={'center'} alignContent={'center'} alignItems={'center'}>
                                <Grid item xs={6}
                                  style={{ textAlign: 'left', borderRight: '1px solid black', paddingLeft: 10 }}>
                                  {service.libelle}
                                </Grid>
                                <Grid item xs={6} style={{
                                  padding: 10,
                                }}>
                                  <Select onChange={this.onChangeServiceLinked(service_index, service.id)}
                                    value={service_linked && service_linked.period}
                                    options={periods.map(period => ({
                                      value: period,
                                      label: period
                                    }))}
                                  />
                                </Grid>
                              </Grid>
                            })
                          }
                          </Grid>
                        }
                      </Grid>
                    })
                  }
                </Grid>
              </Grid>
            </Grid>
          }
        </Grid>
      </EurestoDiv>)
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Interface/Guestonline/index.js